import React from 'react';

const CustomizeReportIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" {...props}>
    <path fill="#4B4B4B" d="M17.348 16H1.652C.74 16 0 15.246 0 14.316V1.684C0 .754.74 0 1.652 0h15.696C18.26 0 19 .754 19 1.684v12.632c0 .93-.74 1.684-1.652 1.684zM5.783 2.105c0-.232-.185-.42-.413-.42H2.065c-.228 0-.413.188-.413.42v11.79c0 .232.185.42.413.42H5.37c.228 0 .413-.188.413-.42V2.105zm5.782 0c0-.232-.185-.42-.413-.42H7.848c-.228 0-.413.188-.413.42v11.79c0 .232.185.42.413.42h3.304c.228 0 .413-.188.413-.42V2.105zm5.783 0c0-.232-.185-.42-.413-.42H13.63c-.228 0-.413.188-.413.42v11.79c0 .232.185.42.413.42h3.305c.228 0 .413-.188.413-.42V2.105z" />
  </svg>

);

export default CustomizeReportIcon;
